import React, { Component } from "react";
import { Spinner } from "reactstrap";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormText
} from "reactstrap";

import axios from "axios";
import { withNamespaces } from "react-i18next";

import { FaCheckCircle, FaPencil } from "react-icons/lib/fa";

var validator = require("email-validator");

const NOT_SUBMITTED = 999;
const UPLOADING = 888;
const COMPLETE = 777;
const PRIVACY = 666;

class Report extends Component {
  constructor(props) {
    super();

    this.state = {
      name: "",
      email: "",
      issue: "",
      formValid: false,
      submissionState: NOT_SUBMITTED,
      uploadProgress: 0,
      jobNumber: null,
      nameValid: false,
      emailValid: false,
      issueValid: false
    };

    this.handleSubmitReport = this.handleSubmitReport.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.agreePrivacy = this.agreePrivacy.bind(this);
    this.showPrivacy = this.showPrivacy.bind(this);
    this.done = this.done.bind(this);
    this.validForm = this.validForm.bind(this);

    this.photos = React.createRef();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  validForm() {
    let invalidStates = {};
    let validState = true;

    if (this.state.issue.length < 5) {
      validState = false;
      invalidStates["issueValid"] = true;
    } else {
      invalidStates["issueValid"] = false;
    }

    if (this.state.name.length < 2) {
      validState = false;
      invalidStates["nameValid"] = true;
    } else {
      invalidStates["nameValid"] = false;
    }

    if (!validator.validate(this.state.email)) {
      validState = false;
      invalidStates["emailValid"] = true;
    } else {
      invalidStates["emailValid"] = false;
    }

    if (validState) {
      return true;
    } else {
      this.setState(invalidStates);
      return false;
    }
  }

  handleSubmitReport() {
    if (!this.validForm()) {
      return;
    }

    this.setState({ submissionState: UPLOADING });
    var data = new FormData();
    let photos = this.photos.current.files;
    if (photos) {
      for (const file of photos) {
        data.append("photos", file, file.name);
      }
    }

    data.append("name", this.state.name);
    data.append("email", this.state.email);
    data.append("issue", this.state.issue);
    data.append("prow", this.props.prow.properties.row_code);
    data.append("lat", this.props.position.lat);
    data.append("lon", this.props.position.lng);
    data.append("lang", this.props.i18n.language)

    var scope = this;
    var config = {
      onUploadProgress: function(progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        scope.setState({ uploadProgress: percentCompleted });
      }
    };

    axios
      //.post("//localhost/reports", data, config)
      .post("https://rightsofway.beacons-npa.gov.uk/reports", data, config)
      .then(function(res) {
        if (!res.data.jobNumber || isNaN(parseInt(res.data.jobNumber, 10))) {
          alert("Sorry, we've had an issue submitting your information.");
          scope.setState({ submissionState: NOT_SUBMITTED, uploadProgress: 0 });
          return;
        }

        scope.setState({
          submissionState: COMPLETE,
          uploadProgress: 0,
          issue: "",
          jobNumber: res.data.jobNumber
        });
      })
      .catch(function(err) {
        console.error("error " + err);
        alert("Sorry, we've had an issue submitting your information.");
        scope.setState({ submissionState: NOT_SUBMITTED, uploadProgress: 0 });
      });
  }

  reportForm() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <ModalHeader><FaPencil className={"icon"} /> {t("report-modal-title")}</ModalHeader>
        <ModalBody>
          <div className="container">
            <Form>
              <FormGroup>
                <Label for="issue" size="lg">
                  {t("report-desc-label")}
                </Label>
                <Input
                  autoFocus
                  type="textarea"
                  name="issue"
                  placeholder={t("report-desc-placeholder")}
                  bsSize="lg"
                  onChange={this.handleInputChange}
                  value={this.state.issue}
                  invalid={this.state.issueValid}
                  maxLength="500"
                />
              </FormGroup>

              <FormGroup>
                <Label for="photos">{t("report-photos-label")}</Label>
                <input
                  type="file"
                  name="photos"
                  multiple="multiple"
                  accept=".jpg,.png,.webp"
                  ref={this.photos}
                />
                <FormText color="muted">
                  {t("report-photo-restrictions")}
                </FormText>
              </FormGroup>
              <FormGroup>
                <Label for="name">{t("report-name-label")}</Label>
                <Input
                  type="text"
                  name="name"
                  placeholder={t("report-name-placeholder")}
                  onChange={this.handleInputChange}
                  value={this.state.name}
                  maxLength="100"
                  invalid={this.state.nameValid}
                />
              </FormGroup>
              <FormGroup>
                <Label for="email">{t("report-email-label")}</Label>
                <Input
                  type="email"
                  name="email"
                  placeholder={t("report-email-placeholder")}
                  onChange={this.handleInputChange}
                  value={this.state.email}
                  invalid={this.state.emailValid}
                  maxLength="150"
                />
              </FormGroup>
              <FormText>
                {t("report-privacy")}{" "}
                <a href="" onClick={this.showPrivacy}>
                  {t("report-privacy-statement")}
                </a>
                .
              </FormText>
            </Form>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="container">
            <Button
              size="lg"
              block
              color="primary"
              onClick={this.handleSubmitReport}
            >
              {t("report-submit")}
            </Button>
            <Button size="lg" block color="link" onClick={this.props.toggle}>
              {t("report-cancel")}
            </Button>
          </div>
        </ModalFooter>
      </React.Fragment>
    );
  }

  uploadingForm() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <ModalBody>
          <div className="container" style={{ textAlign: "center" }}>
            <Spinner
              style={{ width: "3rem", height: "3rem" }}
              color="primary"
            />
            <h3 style={{ marginTop: "10px" }}>
              {this.state.uploadProgress}% {t("uploaded")}
            </h3>
          </div>
        </ModalBody>
      </React.Fragment>
    );
  }

  uploadedForm() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <ModalBody>
          <div className="container">
            <h4 style={{ textAlign: "center" }}>
              <FaCheckCircle
                color="lime"
                style={{ marginTop: "1em", marginBottom: "1em" }}
                size="5em"
              />
              <br />
              <b>#{this.state.jobNumber}</b>
              <br />
              <br />
              {t("report-thankyou")}
            </h4>
            <p style={{ textAlign: "center" }}>
              {t("report-feedback", { jobNumber: this.state.jobNumber })}
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="container">
            <Button size="lg" block color="primary" onClick={this.done}>
              {t("report-complete")}
            </Button>
          </div>
        </ModalFooter>
      </React.Fragment>
    );
  }

  privacy() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <ModalHeader>{t("privacy-title")}</ModalHeader>
        <ModalBody>
          <p>{t("privacy-paragraph-one")}</p>
          <p>{t("privacy-paragraph-two")}</p>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={this.agreePrivacy}>
            <FaCheckCircle className="icon" />
            &nbsp;&nbsp;{t("privacy-understood")}
          </Button>
        </ModalFooter>
      </React.Fragment>
    );
  }

  agreePrivacy() {
    this.setState({ submissionState: NOT_SUBMITTED });
  }

  showPrivacy(e) {
    this.setState({ submissionState: PRIVACY });
    e.preventDefault();
  }

  done() {
    this.props.toggle();
    this.setState({ submissionState: NOT_SUBMITTED, uploadProgress: 0 });
  }

  render() {
    let formContent = null;
    if (this.state.submissionState === NOT_SUBMITTED) {
      formContent = this.reportForm();
    } else if (this.state.submissionState === UPLOADING) {
      formContent = this.uploadingForm();
    } else if (this.state.submissionState === COMPLETE) {
      formContent = this.uploadedForm();
    } else if (this.state.submissionState === PRIVACY) {
      formContent = this.privacy();
    }
    return (
      <div className="container">
        <Modal isOpen={this.props.open} toggle={this.props.toggle}>
          {formContent}
        </Modal>
      </div>
    );
  }
}

export default withNamespaces()(Report);



// WEBPACK FOOTER //
// ./src/Report.jsx